/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-prototype-builtins */
import Skeleton from 'react-loading-skeleton';
import { FC } from 'react';
import { updateAEMCQKeys } from '@marriott/mi-ui-library';
import { StyledCobrandWrapper } from './CobrandWrapper.styles';
import { WrapperProps } from './CobrandWrapper.types';
import { StyledCobrandWrapperSkeletonLoader } from './CobrandWrapperSkeletonLoader.styles';
export const CobrandWrapperConfig = {
  emptyLabel: 'CobrandWrapper',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/cobrandwrapper`,
};

export const CobrandWrapperSkeletonLoader: FC<WrapperProps> = (props: WrapperProps) => {
  updateAEMCQKeys(props);

  return (
    <StyledCobrandWrapper
      data-testid="cobrand-CobrandWrapperSkeletonLoader"
      data-component-name="o-cobrand-CobrandWrapperSkeletonLoader"
    >
      <StyledCobrandWrapperSkeletonLoader className="container pt-5">
        <div className="full-skeleton-block">
          <Skeleton height={5304} baseColor="#ebebeb" highlightColor="#f5f5f5" />
        </div>
      </StyledCobrandWrapperSkeletonLoader>
    </StyledCobrandWrapper>
  );
};
